import { fetch } from "whatwg-fetch";

import { Fetch } from "./Fetch";

export const browserFetchWithPolyfill: Fetch = fetch;
